export const NAME = 'MultiHistoricalFlightStatus';



// WEBPACK FOOTER //
// ./modules/HistoricalFlightStatus/redux/Multi/constants.js